// extracted by mini-css-extract-plugin
export var editInput = "_g5-0";
export var editInputCompact = "_g5-2";
export var editInputLarge = "_g5-1";
export var editInputSmall = "_g5-3";